<template>
  <Dialog
    :visible="showModal"
    :modal="true"
    :closable="false"
    class="payment-success-modal p-dialog-share"
    :breakpoints="{'1360px': '50vw', '1024px': '60vw', '960px': '90vw', '640px': '91vw'}" :style="{width: '35vw'}"
    data-cy="payment-success-dialog"
    pv_id_3
  >
    <template #header>
        <button
          class="p-dialog-header-icon p-dialog-header-close p-link ms-auto"
          type="button"
          @click.prevent="close(false)">
            <i class="p-dialog-header-close-icon pi pi-times"></i>
        </button>
    </template>
    <div class="body">
      <div class="text-center my-4">
        <img v-if="sehatty" :src="`${staticUrl}/static/icons/Success_Sehatty.svg`" alt="success" class='sehatty_logo'/>
        <img v-else-if="useEndowmentTheme" :src="hefSuccessIcon" alt="success" class="hef-success-icon"/>
        <i v-else class="pi pi-check-circle m-auto color-primary fs-large"></i>
      </div>
      <div :class="appendSehattyClass('my-2 text-center color-primary')" v-if="$store.getters.isAuthenticated && !isHefType">
        {{ username }}
      </div>
      <div :class="[useEndowmentTheme ? 'hef-heading' : 'color-primary', 'text-center mb-2 fw-bold dir-rtl']">
        {{ heading }}
      </div>
      <div class="color-complementary text-center mb-3 fw-bold" v-if="!isHefType">
        {{ message }}
      </div>
      <div :class="[appendSehattyClass('text-center mb-2'), useEndowmentTheme ? 'hef-total-label' : 'color-primary']" data-cy="total-donation-message">
        إجمالي التبرع
      </div>
      <div :class="[appendSehattyClass('amount-tag rounded m-auto text-center p-1 mb-4 d-flex justify-content-center flex-row-reverse'), { 'hef-amount': useEndowmentTheme }]" data-cy="donation-amount">
        <span class="px-1">{{ data.amount }}</span>
        <div :class="['sar-icon mt-1', { 'sar-icon--hef': useEndowmentTheme }]" />
      </div>
      <div class="w-75 m-auto">
        <div v-if="isSpecificDonationType && !periodicDonation && donationType !== donationType_.MAJOR_DONOR">
          <div v-if="!periodicDonation" :class="[appendSehattyClass('d-block text-center fs-6'), useEndowmentTheme ? 'hef-share-text' : 'color-complementary']" data-cy="share-with-others-message">
            ساهم في العلاج عن طريق مشاركتك الحالة للآخرين
          </div>
          <div v-if="!periodicDonation" :class="[appendSehattyClass('input-wrapper mt-1 mb-4'), { 'hef-input-wrapper': useEndowmentTheme }]" data-cy="share-with-others">
            <InputText type="text" v-model="sharableLink" :placeholder="isGeneratingLink ? '...جاري إنشاء الرابط' : ''" disabled ref="shareInput" />
            <Button :class="[appendSehattyClass('p-input-text__icon-wrapper'), { 'hef-copy-btn': useEndowmentTheme }]" @click="copyLink" :disabled="isGeneratingLink">
              <i class="pi pi-copy" />
            </Button>
          </div>
        </div>
        <div class="details-table fs-6 mb-4">
          <div :class='appendSehattyClass("header d-flex justify-content-between align-items-center flex-row-reverse rounded-4 px-2 px-lg-5 py-1")'>
            <div class="mb-2" data-cy="reference-number-label">رقم المرجع</div>
            <div :class="appendSehattyClass('table-val fw-bold')" data-cy="reference-number">{{ data.reference_number }}</div>
          </div>
          <div :class='appendSehattyClass("item d-flex justify-content-between align-items-center flex-row-reverse px-3 py-2")'>
            <div class="mb-2 text-end" data-cy="date-time-label">التاريخ والوقت</div>
            <div :class='appendSehattyClass("table-val fw-bold dir-rtl text-start")' data-cy="date-time">{{ data.date }}</div>
          </div>
          <div :class="appendSehattyClass('item d-flex justify-content-between align-items-center flex-row-reverse px-3 py-2')">
            <div class="mb-2" data-cy="payment-method-label">طريقة الدفع</div>
            <div :class="appendSehattyClass('table-val fw-bold')" data-cy="payment-method">{{ data.payment_method }} </div>
          </div>
          <div :class="appendSehattyClass('item d-flex justify-content-between align-items-center flex-row-reverse px-3 py-2')"
            v-if="isSpecificDonationType && !periodicDonation">
            <div v-if="donationType === donationType_.CAMPAIGN || donationType === donationType_.CASE || donationType === donationType_.WAQF || donationType === donationType_.MAJOR_DONOR || donationType === donationType_.HEF"
              class="mb-2" data-cy="case-id-label">
              {{ donationType === donationType_.CAMPAIGN ? 'رقم الحملة' : donationType === donationType_.WAQF ? 'رقم الوقف' : donationType === donationType_.HEF ? 'رقم الوقف' : 'رقم الحالة' }}
            </div>
            <div :class="appendSehattyClass('table-val fw-bold')" data-cy="case-id">{{ data.id }}</div>
          </div>
          <div :class="appendSehattyClass('item d-flex justify-content-between align-items-center flex-row-reverse px-3 py-2')" v-if="!isHefType">
            <div class="mb-2" data-cy="donation-specialty-label">نوع التبرع</div>
            <div :class="appendSehattyClass('table-val fw-bold')" v-if="!periodicDonation" data-cy="donation-specialty">{{ data.specialty }}</div>
            <div class="text-black fw-bold" v-else>تبرع دوري</div>
          </div>
          <div :class="appendSehattyClass('item d-flex justify-content-between align-items-center flex-row-reverse px-3 py-2')"
               v-if="isSpecificDonationType && !periodicDonation && !isHefType">
            <div class="mb-2" data-cy="case-details-label">تفاصيل الحالة</div>
            <div class="fw-bold">
              <a :href="sharableLink" target="_blank" :class="appendSehattyClass('color-complementary')" data-cy="case-details-link">
                إظهار تفاصيل الحالة
              </a>
            </div>
          </div>
          <div :class="appendSehattyClass('item d-flex justify-content-between align-items-center flex-row-reverse px-3 py-2')"
               v-if="periodicDonation">
            <div class="mb-2">تفاصيل الخدمة</div>
            <div class="fw-bold">
              <router-link to="/admin-panel/periodic-donation" class="color-complementary">
                إظهار تفاصيل الخدمة
              </router-link>
            </div>
          </div>
        </div>
        <div class="text-center">
          <button
            id="submit-btn"
            :class="[appendSehattyClass('btn btn-primary btn-lg submit-btn rounded-5 px-5 text-white'), { 'hef-submit-btn': useEndowmentTheme }]"
            type="button"
            @click.prevent="close(true)"
            data-cy="home-page">
            {{ buttonLabel ? buttonLabel :  'الصفحة الرئيسية'}}
          </button>
        </div>
      </div>
    </div>
  </Dialog>
</template>

<script>
import { ToastSeverity } from "primevue/api";
import { DONATION_TYPE } from "@/services/enum.service";
import { appendSehattyClass, getDomainWithoutProtocol } from "@/helpers/helpers";
import JwtUtilService from "@/services/jwt.util.service";
import AmbassadorService from "@/services/ambassador.service";
import hefSuccessIcon from "@/assets/icons/success-gradient.svg";
export default {
  name: "DonationSuccessDialog",
  inject: ['staticUrl'],
  props: ["data", "showModal", "donationType", "heading", "message", "buttonLabel", "buttonLink", "periodicDonation",'sehatty', 'isEndowmentMode'],
  emits: ["close"],
  data() {
    return {
      sharableLink: "",
      isGeneratingLink: false,
      username: localStorage.getItem("username"),
      donationType_: DONATION_TYPE,
      is_waqf_wallet: localStorage.getItem("is_waqf_wallet") ? JSON.parse(localStorage.getItem("is_waqf_wallet")) : false,
      canShareTrackableLink: JwtUtilService.getClientID()?.includes("doner") && this.$store.getters.isAuthenticated,
      hefSuccessIcon,
    };
  },
  mounted() {
  this.generateLink();

    // Google Analytics - Donation Completed
    if (window.gtag && this.data?.amount) {
      window.gtag('event', 'donation_completed', {
        donation_amount: this.data.amount,
        currency: 'SAR',
        page_title: document.title,
        source: 'web',
        donation_type: this.donationType,
        object_id: this.data.reference_number,
      });
    }
  },
  methods: {
    appendSehattyClass,
    async generateLink() {
      if (this.periodicDonation) {
        this.sharableLink = process.env.VUE_APP_FE_URL;
        this.sharableLink += "/admin-panel/periodic-donation";
      } else if (this.sehatty) {
        this.sharableLink = process.env.VUE_APP_FE_URL;
        this.sharableLink += '/sehatty';
      } else {
        const domain = `https://${getDomainWithoutProtocol()}`;
        if (this.canShareTrackableLink) {
          this.isGeneratingLink = true;
          try {
            let response;
            switch (this.donationType) {
              case DONATION_TYPE.CASE:
                response = await AmbassadorService.postCaseNumber({ case: this.data.id });
                this.sharableLink = `${domain}/c/${response.data.result.case}/${response.data.result.id}`;
                break;
              case DONATION_TYPE.WAQF:
                response = await AmbassadorService.postWaqfNumber({ waqf: this.data.id });
                this.sharableLink = `${domain}/w/${response.data.result.waqf}/${response.data.result.id}`;
                break;
              case DONATION_TYPE.CAMPAIGN:
                response = await AmbassadorService.postCampaignNumber({ campaign: this.data.id });
                this.sharableLink = `${domain}/p/${response.data.result.campaign}/${response.data.result.id}`;
                break;
              case DONATION_TYPE.HEF:
                this.sharableLink = `${domain}/h/${this.data?.id}/`;
                break;
            }
          } catch (error) {
            this.generateNonTrackableLink(domain);
          } finally {
            this.isGeneratingLink = false;
          }
        } else {
          this.generateNonTrackableLink(domain);
          this.isGeneratingLink = false;
        }
      }
    },
    generateNonTrackableLink(domain) {
      switch (this.donationType) {
        case DONATION_TYPE.CASE: {
          if (this.sehatty) {
            this.sharableLink = `${domain}/donate-case/${this.data.id}?sehatty=true`;
          } else {
            this.sharableLink = `${domain}/c/${this.data?.id}`;
          }
          break;
        }
        case DONATION_TYPE.MAJOR_DONOR: {
          this.sharableLink += "?object_type=case";
          break;
        }
        case DONATION_TYPE.WAQF: {
          this.sharableLink = `${domain}/w/${this.data?.id}`;
          break;
        }
        case DONATION_TYPE.CAMPAIGN: {
          this.sharableLink = `${domain}/p/${this.data?.id}`;
          break;
        }
        case DONATION_TYPE.HEF: {
          this.sharableLink = `${domain}/h/${this.data?.id}/`;
          break;
        }
      }
    },
    copyLink() {
      if (navigator.clipboard && navigator.clipboard.writeText) {
        navigator.clipboard.writeText(this.sharableLink).then(() => {
          if (this.sharableLink) {
            this.$toast.add({severity: ToastSeverity.SUCCESS, detail: "تم النسخ بنجاح", life: 3000});
          }
        }, () => {
          if (this.sharableLink) {
            this.$toast.add({severity: ToastSeverity.ERROR, detail: "فشل نسخ الرابط", life: 3000});
          }
        });
      } else {
        const input = this.$refs.shareInput.$el;
        input.disabled = false;
        input.select();
        document.execCommand("copy");
        input.disabled = true;
        window.getSelection().removeAllRanges();
        if (this.sharableLink) {
          this.$toast.add({ severity: ToastSeverity.SUCCESS, detail: "تم النسخ بنجاح", life: 3000 });
        }
      }
    },
    close(isRedirectHome) {
      localStorage.setItem("is_waqf_wallet", false);
      if (isRedirectHome) {
        this.redirectHome();
      } else {
        this.redirectToPreviousPage();
      }
      this.$emit("close");
    },
    redirectToPreviousPage() {
      let path = "/";
      if (this.buttonLink) {
        path = "/admin-panel/periodic-donation";
      } else if (this.data?.id) {
        switch (this.donationType) {
          case DONATION_TYPE.CASE:
            path = `/donate-case/${this.data.id}`;
            if(this.sehatty){
              path += "?sehatty=true";
            }
            break;
          case DONATION_TYPE.MAJOR_DONOR:
            path = `/donate-case/${this.data.id}`;
            break;
          case DONATION_TYPE.CAMPAIGN:
            path = `/donate-campaign/${this.data.id}`;
            break;
          case DONATION_TYPE.WAQF:
            if (!this.is_waqf_wallet) {
              path = `/donate-waqf/${this.data.id}`;
            }
            break;
        }
      }
      this.$router.push(path);
    },
    redirectHome() {
      let path = "/";
      if (this.buttonLink) {
        path = "/admin-panel/periodic-donation";
      }
      else if(this.sehatty){
        path = "/sehatty";
      }
      this.$router.push(path);
    }
  },
  computed: {
    isHefType() {
      return this.donationType === DONATION_TYPE.HEF;
    },
    useEndowmentTheme() {
      return this.isHefType || this.isEndowmentMode;
    },
    isSpecificDonationType() {
      const typesToExclude = [
        this.donationType_.ALL_CASES_DONATION,
        this.donationType_.ZAKAT,
        this.donationType_.ALL_PATIENTS
      ];
      return !typesToExclude.includes(this.donationType);
    },
  }
};
</script>

<style lang="scss" scoped>
@import "@/styles/variables";
@import "@/styles/components/riyal-logo";

.table-val {
  color: #000;
  &.sehatty{
    color: $color-text-sehatty;
  }
}
.sehatty_logo {
  width: 100px;
  height: 100px;
}
.hef-success-icon {
  width: 80px;
  height: 80px;
}
.hef-total-label {
  color: #6B7280;
}
.hef-amount {
  background: #E7F7F7 !important;
  color: #007F5C !important;
}
.hef-heading {
  color: #000;
  font-size: 1.5rem;
}
.hef-input-wrapper {
  margin-top: 1rem !important;
}
.hef-share-text {
  color: #007F5C;
}
.hef-copy-btn {
  background: #007F5C !important;
  border-color: #007F5C !important;
  &:hover {
    background: #006B4F !important;
    border-color: #006B4F !important;
  }
}
.hef-submit-btn {
  background: #007F5C !important;
  border-color: #007F5C !important;
  &:hover {
    background: #006B4F !important;
    border-color: #006B4F !important;
  }
}
.sar-icon--hef {
  filter: brightness(0) saturate(100%) invert(33%) sepia(98%) saturate(394%) hue-rotate(118deg) brightness(95%) contrast(101%);
  opacity: 1;
}
.payment-success-modal {
  .amount-tag {
    width: 110px;
    background: #E7F7F7;
    color: $color-primary;
    &.sehatty{
      background: $color-sehatty-stroke;
      color: $color-primary-sehatty;
    }
  }

  .input-wrapper {
    width: auto !important;
  }

  .details-table {
    .header {
      background: #ECECEC;
      &.sehatty{
        background: $color-sehatty-stroke;
      }
    }

    .item:not(:last-child) {
      border-bottom: 1px solid $color-secondary;
    }
    .item{
      &.sehatty{
        color: $color-sehatty-gray;
      }
    }
  }

  .submit-btn {
    background: $color-primary;
    border-color: $color-primary;
    transition: all 0.5s;
    &.sehatty{
      background: $color-primary-sehatty;
      border-color: $color-primary-sehatty;
      &:hover {
        background: $color-primary-sehatty;
        border-color: $color-primary-sehatty;
        opacity: 0.9;
      }
    }

    &:hover {
      background: $color-primary;
      border-color: $color-primary;
      opacity: 0.9;
    }
  }
}


.color-primary {
  color: $color-primary;
  &.sehatty{
    color: $color-primary-sehatty;
  }
}

.color-complementary {
  color: $color-complementary;
  &.sehatty{
    color: $color-complementary-sehatty;
  }
}

.fs-large {
  font-size: 60px;
}

.dir-rtl {
 direction: rtl;
}
</style>
